import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmployeePaymentHistorySchema = withDefaults({
  type: 'employee-payment-history',
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'paymentDate',
    },
    {
      kind: 'attribute',
      name: 'benefitPeriod',
    },
    {
      kind: 'attribute',
      name: 'lineItemType',
    },
    {
      kind: 'attribute',
      name: 'servicer',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
  ],
});

export default EmployeePaymentHistorySchema;
